import { render, staticRenderFns } from "./DMLandingPage.vue?vue&type=template&id=463ff06e&scoped=true"
import script from "./DMLandingPage.vue?vue&type=script&lang=js"
export * from "./DMLandingPage.vue?vue&type=script&lang=js"
import style0 from "./DMLandingPage.vue?vue&type=style&index=0&id=463ff06e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463ff06e",
  null
  
)

export default component.exports